import { validator } from "LIB/validate-this";
import { LINE_ITEMS } from "APP_ROOT/constants";
import * as rules from "LIB/validation/rules";
import {
  INVENTORY,
  SRP_CONDITION,
  SUGGESTED_RETAIL
} from "MODULES/inventories/constants";

export function validateLineItem(lineItem) {
  lineItem.validateChild(INVENTORY, inventory => {
    inventory
      .validate(SUGGESTED_RETAIL)
      .satisfies(rules.required, rules.isGreaterThanOrEqualTo(0));

    inventory.validate(SRP_CONDITION).satisfies(rules.required);
  });
}

export default function validate(values) {
  return validator(values, form => {
    form.validateChildren(LINE_ITEMS, validateLineItem);
  });
}



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Actions/Cancel/validate.js